import React from "react";
import "./Product.scss";
import {useFixedHeader} from "../../utils/headerHelper";
import {FooterFixed} from "../../components/FooterFixed";
import {BlackModal} from "../../components/BlackModal/BlackModal";
import {SubmitInfo} from "../../components/SubmitInfo/SubmitInfo";
import {Redirect, Route, Switch} from "react-router-dom";
import {RPEX6} from "./components/RPEX6";
import {RPEX9} from "./components/RPEX9";
import {RLED6} from "./components/RLED6";
import {RSmartMini} from "./components/RSmartMini";
import {RSmartPlus} from "./components/RSmartPlus";
import {RSmartPro} from "./components/RSmartPro";
import {RSmartClassic} from "./components/RSmartClassic";
import {RSmartExpert} from "./components/RSmartExpert";
import {RSmartMate} from "./components/RSmartMate";
import {RSmartWClassic} from "./components/RSmartWClassic";
import {RSmartWExpert} from "./components/RSmartWExpert";
import {RSmartWPro} from "./components/RSmartWPro";
import {RSmartMotorE} from "./components/RSmartMotorE";
import {RSmartMotorS} from "./components/RSmartMotorS";
import {RSmartMotorAI} from "./components/RSmartMotorAI";
import {dxq} from "./components/DXQ";
import {R3} from "./components/R3";
import {MCure1} from "./components/MCure1";
import {MCure3} from "./components/MCure3";
import {MCure6} from "./components/MCure6";
import {MCure8} from "./components/MCure8";
import {MCure9} from "./components/MCure9";
import {MCureLX} from "./components/MCureLX";
import {MCureL1} from "./components/MCureL1";
import {MCureT5} from "./components/MCureT5";
import {MCureT7} from "./components/MCureT7";
import {MC1} from "./components/MC1";
import {MC3} from "./components/MC3";
import {MC8} from "./components/MC8";
import {MC9} from "./components/MC9";
import {MX} from "./components/MX";
import {MCL1} from "./components/MC L1";
import {MCT5} from "./components/MC T5";
import {MCT7} from "./components/MC T7";
import {RSmartPlus2} from "./components/RSmartPlus+";
import {RSmartMax} from "./components/RSmartMax";
import {RXPlus2} from "./components/RXPlus+";
import {RXMax} from "./components/RXMax";
import {MopexE} from "./components/MopexE";
import {MopexS} from "./components/MopexS";
import {MopexW} from "./components/MopexW";
import {MopexAI} from "./components/MopexAI";
import {SMotorAI} from "./components/SMotorAI";
import {SMotorE} from "./components/SMotorE";
import {SMotorS} from "./components/SMotorS";

export function Product() {

    useFixedHeader();

    return <>
        <main className="news-content main-content">
            <div className="product-img-wrapper">
                <Switch>
                    <Route exact path="/product" component={() => <Redirect to="/product/rpex6"/>}/>
                    <Route path="/product/RPEX6" component={RPEX6}/>
                    <Route path="/product/RPEX9" component={RPEX9}/>
                    <Route path="/product/R-SmartMini" component={RSmartMini}/>
                    <Route path="/product/R-SmartPlus" component={RSmartPlus}/>
                    <Route path="/product/R-SmartClassic" component={RSmartClassic}/>
                    <Route path="/product/R-SmartExpert" component={RSmartExpert}/>
                    <Route path="/product/R-SmartPro" component={RSmartPro}/>
                    <Route path="/product/R-SmartWClassic" component={RSmartWClassic}/>
                    <Route path="/product/R-SmartWExpert" component={RSmartWExpert}/>
                    <Route path="/product/R-SmartWPro" component={RSmartWPro}/>
                    <Route path="/product/R-SmartMotorE" component={RSmartMotorE}/>
                    <Route path="/product/R-SmartMotorS" component={RSmartMotorS}/>
                    <Route path="/product/R-SmartMotorAI" component={RSmartMotorAI}/>
                    <Route path="/product/R-SmartMate" component={RSmartMate}/>
                    <Route path="/product/RLED6" component={RLED6}/>
                    <Route path="/product/UltraR6" component={dxq}/>
                    <Route path="/product/Ultra3" component={R3}/>
                    <Route path="/product/M-Cure1" component={MCure1}/>
                    <Route path="/product/M-Cure3" component={MCure3}/>
                    <Route path="/product/M-Cure6" component={MCure6}/>
                    <Route path="/product/M-Cure8" component={MCure8}/>
                    <Route path="/product/M-Cure9" component={MCure9}/>
                    <Route path="/product/M-CureLX" component={MCureLX}/>
                    <Route path="/product/M-CureL1" component={MCureL1}/>
                    <Route path="/product/M-CureT5" component={MCureT5}/>
                    <Route path="/product/M-CureT7" component={MCureT7}/>
                    <Route path="/product/MC1" component={MC1}/>
                    <Route path="/product/MC3" component={MC3}/>
                    <Route path="/product/MC8" component={MC8}/>
                    <Route path="/product/MC9" component={MC9}/>
                    <Route path="/product/MX" component={MX}/>
                    <Route path="/product/MCL1" component={MCL1}/>
                    <Route path="/product/MCT5" component={MCT5}/>
                    <Route path="/product/MCT7" component={MCT7}/>

                    <Route path="/product/R-SmartPlus+" component={RSmartPlus2}/>
                    <Route path="/product/R-SmartMax" component={RSmartMax}/>
                    <Route path="/product/RXPlus+" component={RXPlus2}/>
                    <Route path="/product/RXMax" component={RXMax}/>
                    <Route path="/product/MopexE" component={MopexE}/>
                    <Route path="/product/MopexS" component={MopexS}/>
                    <Route path="/product/MopexW" component={MopexW}/>
                    <Route path="/product/MopexAI" component={MopexAI}/>
                    <Route path="/product/SMotorAI" component={SMotorAI}/>
                    <Route path="/product/SMotorE" component={SMotorE}/>
                    <Route path="/product/SMotorS" component={SMotorS}/>



                </Switch>
            </div>
            <SubmitInfo/>
            <BlackModal/>
        </main>
        <FooterFixed/>
    </>

}
